<div class="print-history-popup">
  <div class="print-history-popup-body">
    <h2 class="popup-title">
      {{ 'GUI.Patient History.PrintHistory.Print History' | translate }}
    </h2>
    <button (click)="close()" class="print-history-popup-close" aria-label="close popup"></button>

    <img *ngIf="loadingPrint" src="../../assets/images/Wedges.svg" class="pdf-loader" />

    <div class="print-table-scroll" *ngIf="!loadingPrint && pregnancyReports.length">
      <table mat-table [dataSource]="pregnancyReports" class="mat-elevation-z8 print-table">
        <ng-container matColumnDef="print">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <img
              class="print-history-icon"
              src="../../assets/icons/print-history.svg"
              [matTooltip]="'GUI.Tooltips.Print' | translate | titlecase"
            />
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'GUI.Patient History.Exam Name' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ examName(element) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'GUI.Patient History.PrintHistory.Date' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element?.creationDate | date: 'dd/MM/yyyy' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row (click)="openReport(row)" *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <p class="print-history-message" *ngIf="!loadingPrint && !pregnancyReports.length && !hasError">
      {{ 'GUI.Patients.empty.exams' | translate }}
    </p>
    <p class="print-history-message" *ngIf="!loadingPrint && hasError">
      {{ 'GUI.errorMessages.Error' | translate }}
    </p>
  </div>
</div>
